<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/numeral-colour';
            },
            cache_key(){
                return '_' + 'numeral-colour' + '_' + this.fabricator;
            },
        },
    }
</script>
